import { render, staticRenderFns } from "./CongelationCuveShipped.vue?vue&type=template&id=457c239d&"
import script from "./CongelationCuveShipped.vue?vue&type=script&lang=js&"
export * from "./CongelationCuveShipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports